import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { campaignIds: Array }
  static targets = ["row"]

  connect() {
    this.isConnected = true

    this.timeoutId = setTimeout(() => {
      this.#statusUpdate()
    }, 5000)
  }

  disconnect() {
    clearTimeout(this.timeoutId)
    this.isConnected = false
  }

  async #statusUpdate() {
    if (!this.isConnected) {
      return
    }

    const response = await fetch(`/campaigns.json?ids=${this.campaignIdsValue.join(",")}`)
    const data = await response.json()

    for (const campaign of data) {
      if (!this.isConnected) {
        return
      }

      const campaignRow = this.rowTargets.find((row) => parseInt(row.dataset.campaignId) === campaign.id)

      if (campaignRow && campaignRow.dataset.campaignStatus !== campaign.status) {
        await this.#refresh(campaignRow)
      }
    }

    if (this.isConnected) {
      clearTimeout(this.timeoutId)
      this.timeoutId = setTimeout(() => {
        this.#statusUpdate()
      }, 5000)
    }
  }

  async #refresh(campaignRow) {
    const response = await fetch(`/campaigns/${campaignRow.dataset.campaignId}?view=row`)
    const html = await response.text()

    campaignRow.outerHTML = html
  }
}
